export const roundOff = (num, numDigitsAfterDecimal=5) => {
    if(numDigitsAfterDecimal < 0) throw Error("Number of digits after decimal cannot be negtive")
    const numDigits = 10**numDigitsAfterDecimal
    return Math.round((num + Number.EPSILON)* numDigits) / numDigits
}